
import React from 'react';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import CustomPaginationActionsTable from '../Assetapprove/ApproveTable';
import PreviewEdit from './PreviewEdit'

const Container = styled.div``

const Assetapprove = () => {
   
  const [id, setId] = useState('');
  const [changePage, setChangePage] = useState([true, false])

  const handlePreview = (e, id) => {
    setChangePage([false, true])
    setId(id)
  }

  return (
    <Container>
      {changePage[1] &&<PreviewEdit reqid={id} setChangePage={setChangePage}/>}
      {changePage[0] &&<CustomPaginationActionsTable handlePreview={handlePreview} />}
    </Container>
  )
}

export default Assetapprove;